<template>
  <div class="popup">
    <div class="popup__title">
      <div class="title" v-if="getModalData.id">Edit Pest</div>
      <div class="title" v-else>Add Pest</div>
    </div>
    <v-slick ref="slick" class="popup__typesetting mt-4" :options="slickOptions">
      <div class="popup__language" v-for="item of getLangOptions" :class="{active: item.value == lang}" @click="lang = item.value">
        <img :src="'/img/lang/' + item.value + '.png'" :alt="item.label" class="popup__pennant"/>
        <div class="popup__language-name">{{ item.label }}</div>
      </div>
    </v-slick>
    <form class="form" @submit.prevent="onSubmit">
      <div class="form__bent">
        <label class="form__label">Name</label>
        <input type="text" class="form__field" v-model="form.name[lang]"/>
      </div>
      <div class="form__bent">
        <label class="form__label">Countries</label>
        <vue-select id="userCountry" v-model="form.countries_id" :options="getCountriesOptions()" :settings="{multiple: true}"></vue-select>
      </div>
      <div class="form__btn">
        <button class="btn" type="submit" v-if="getModalData.id">Save</button>
        <button class="btn" type="submit" v-else>Add</button>
      </div>
    </form>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex'

  export default {
    name: 'ModalPest',
    data() {
      return {
        lang: 'en',
        form: {
          name: {},
          countries_id: [],
        },
        slickOptions: {
          slidesToShow: 4,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
          infinite: false,
          responsive: [
            {
              breakpoint: 992,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
              }
            },
            {
              breakpoint: 576,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
              }
            },
          ]
        },
      }
    },
    computed: {
      ...mapGetters([
        'getLangOptions',
        'getCountriesOptions',
        'getModalData',
      ]),
    },
    mounted() {
      if (this.getModalData.id) {
        this.form = {
          name: this.getModalData.name,
          countries_id: this.getModalData.countries_id,
        }
      }
    },
    methods: {
      ...mapActions([
        'storePest',
        'updatePest',
      ]),
      onSubmit() {
        if (this.getModalData.id)
          this.updatePest([this.getModalData.id, this.form])
        else
          this.storePest(this.form)
      }
    }
  }
</script>

<style scoped>
  .popup { padding: 50px 100px !important }
</style>